import React, { FunctionComponent, useState } from 'react'
import { Button, ButtonProps } from '@afterpaytouch/core'
import { LoaderModal } from '../LoaderModal'
import { useCloseCheckout } from '../../utils/close'
import { create } from 'react-modal-promise'
import { LeaveCheckoutModal } from '../LeaveCheckoutModal'
import { useCheckoutStatus, useCountry, useIsConsumerLendingOrder, useIsExtendedFraudAlert } from '../../state'
import { Route } from '../../config/router'
import { useRouter } from 'next/router'
import { CheckoutStatus } from '../../model'
import { Country } from '@afterpay/types'

interface Props extends ButtonProps {
  onClick?: () => void
}

export const CloseCheckout: FunctionComponent<Props> = ({ children, onClick = () => {}, type = 'button', size = 'Large', ...buttonProps }) => {
  const [showLoaderModal, setShowLoaderModal] = useState(false)
  const close = useCloseCheckout()
  const isConsumerLending = useIsConsumerLendingOrder()
  const checkoutStatus = useCheckoutStatus()
  const showLeaveModal = create(LeaveCheckoutModal)
  const { pathname } = useRouter()
  const country = useCountry()
  const isExtendedFraudAlert = useIsExtendedFraudAlert()

  // Show LeaveCheckoutModal on these pages: payment-options, add-payment-method for consumer lending, consumer-lending-summary, truth-in-lending
  // and pay-monthly-only page in US pay monthly only flow
  const shouldShowLeaveModal =
    country === Country.US &&
    pathname !== Route.TERMINAL_ERROR &&
    checkoutStatus !== CheckoutStatus.Closed &&
    (isConsumerLending || pathname === Route.PAYMENT_OPTIONS || pathname === Route.PAY_MONTHLY_ONLY) &&
    !isExtendedFraudAlert

  const handleClick = async (): Promise<void> => {
    if (shouldShowLeaveModal) {
      try {
        await showLeaveModal()
      } catch (e) {
        return
      }
    }
    setShowLoaderModal(true)
    onClick()
    close()
  }

  return (
    <>
      <Button type={type} size={size} {...buttonProps} onClick={handleClick}>
        {children}
      </Button>
      {showLoaderModal && <LoaderModal />}
    </>
  )
}
